import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { FeatureSection } from '../components/FeatureSection';
import { Reputation } from '../components/Reputation';
import { AIReceptionist } from '../components/AIReceptionist';
import { Onboarding } from '../components/Onboarding';
import { AdReporting } from '../components/AdReporting';
import { ClosingCTA } from '../components/ClosingCTA';
import { SEOHead } from '../components/SEOHead';
import { crmFeatures, automations, marketing } from '../data/howItWorks';
export function HowItWorks() {
  return <>
      <SEOHead title="How It Works | One CRM, AI Receptionist & Marketing System | Viridia Analytics" description="Everything in one system: CRM, AI receptionist, automations, marketing, reputation, and ad reporting, built with you for Phoenix home-service businesses." canonical="/how-it-works" data-id="element-2555" data-mp="1jij5xw0rg4vh" />

      <PageHeader label="How it works" title="One login. One system. One team." intro="Instead of fifty logins and a vendor for every problem, all of it runs in one place. Solo operator or five crews." data-id="element-2556" data-mp="10tw1nfqerjiy" />

      <FeatureSection label="The CRM" title="Every lead and every job in one place." body="Nothing lives in a notebook on the dash or a text thread you scroll back through at 9pm." features={crmFeatures} alt data-id="element-2557" data-mp="1nql7f4e1lvqj" />

      <FeatureSection label="Automations" title="Nobody goes cold because you got busy." body="Built with you on a call, in your voice. Then they run without you." features={automations} columns={3} data-id="element-2558" data-mp="191or6k1u1ceu" />

      <FeatureSection label="Marketing" title="The cheapest job is the repeat customer." body="Stay in front of the people who already paid you once." features={marketing} alt data-id="element-2559" data-mp="100qxovp0snai" />

      <Reputation data-id="element-2560" data-mp="2uc5kp4qnc8mk" />
      <AIReceptionist data-id="element-2561" data-mp="2pfoqptwrn01k" />
      <Onboarding data-id="element-2562" data-mp="2pggmb4qd4xru" />
      <AdReporting data-id="element-2563" data-mp="2pfyedauc8v43" />
      <ClosingCTA data-id="element-2564" data-mp="2pdc6tb7g6flv" />
    </>;
}